// extracted by mini-css-extract-plugin
export default {"visitorCTA":"VisitorCTA_visitorCTA__9wlUh","text":"VisitorCTA_text__sh-Gp"};